var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('h1',[_vm._v("OI")]),_c('v-file-input',{attrs:{"accept":"image/*","label":"File input"},model:{value:(_vm.file),callback:function ($$v) {_vm.file=$$v},expression:"file"}}),_c('img',{attrs:{"src":_vm.fileUploaded}}),_c('v-btn',{on:{"click":function($event){return _vm.uploadFile()}}},[_vm._v("Enviar")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }